import { useTheme } from "@mui/material";
import Select from "react-select";
import { GroupBase } from "react-select";
import { Props } from "react-select";
/**
 * this is react-select customizable compoent
 */
type SelectProps<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
> = Props<Option, IsMulti, Group> & {
  MyCustomProperty?: string;
  MyOtherCustomProperty?: number;
};

export const SelectComponent = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: SelectProps<Option, IsMulti, Group>
) => {
  const theme = useTheme();

  return (
    <Select
      styles={{
        control: (base, state) => ({
          ...base,
          borderColor: state.isFocused ? theme.palette.error.main : theme.palette.divider,
          boxShadow: state.isFocused ? `0 0 0 1px ${theme.palette.error.main}` : undefined,
          "&:hover": {
            borderColor: state.isFocused ? theme.palette.error.main : theme.palette.divider
          }
        }),
        option: (base, state) => ({
          ...base,
          ":hover": {
            backgroundColor: theme.palette.divider
          },
          backgroundColor: state.isSelected ? theme.palette.error.light : undefined
          // color: state.isSelected ? theme.palette.secondary.contrastText : undefined
        }),
        input: (base) => ({
          ...base,
          color: theme.palette.text.primary
        })
      }}
      {...props}
    />
  );
};
